module.exports = __webpack_public_path__ + "static/img/ddhzyk-img11.ec43fafc.jpg";